import { render, staticRenderFns } from "./CampaignsListView.vue?vue&type=template&id=af2dcf92"
import script from "./CampaignsListView.vue?vue&type=script&lang=js"
export * from "./CampaignsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports